import { useState } from 'react';
import { FlaskConical, LogOut, Undo2 } from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';
import { sandboxVisit } from '@/lib/api';
import { fmtDateTime } from '@/lib/format';

/**
 * شريطُ «أنت داخل حسابٍ تجريبي» — يظهر فوق كل صفحةٍ ما دامت إدارةُ المنصة داخل
 * حسابٍ تجريبي (21 سبتمبر 2026). بلا هذا الشريط ينسى المديرُ أين هو فيظنّ ما يراه
 * صلاحياتِه، أو يبحث عن طريق العودة. والزرُّ يعيده إلى جلسته هو لا إلى صفحة الدخول.
 */
export function SandboxBanner() {
  const { sandboxAs, returnFromSandbox, me, signOut } = useAuth();
  const [busy, setBusy] = useState(false);
  // زائرٌ دخل بكودٍ تجريبي (0091): لا إدارةَ يعود إليها — الشريطُ يقول الكودَ ونهايتَه، والخروجُ خروج
  const visit = !sandboxAs && me ? sandboxVisit.get() : null;
  if (visit) {
    return (
      <div className="sandbox-banner" role="status">
        <FlaskConical size={16} aria-hidden />
        <span className="grow">
          دخولٌ تجريبي — <strong>{visit.as}</strong> باسم {visit.visitorName}. ينتهي تلقائياً <span className="num">{fmtDateTime(visit.until)}</span>.
        </span>
        <button type="button" className="sandbox-banner__back" disabled={busy} onClick={() => { setBusy(true); void signOut().finally(() => { setBusy(false); window.location.assign('/try'); }); }}>
          <LogOut size={15} aria-hidden /> خروج
        </button>
      </div>
    );
  }
  if (!sandboxAs) return null;
  return (
    <div className="sandbox-banner" role="status">
      <FlaskConical size={16} aria-hidden />
      <span className="grow">
        أنت داخل حسابٍ تجريبي: <strong>{sandboxAs}</strong> — ترى ما يراه صاحبُ هذا الدور بصلاحياته هو.
      </span>
      <button
        type="button" className="sandbox-banner__back" disabled={busy}
        onClick={() => {
          setBusy(true);
          void returnFromSandbox().finally(() => setBusy(false));
        }}
      >
        <Undo2 size={15} aria-hidden /> عُد إلى إدارة المنصة
      </button>
    </div>
  );
}
